var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/utils/get-quick-actions.ts
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
var GET_QUICK_ACTIONS_MESSAGE_TYPE = "get_quick_actions";
var getQuickActions = (version = 3) => SocketAsFetch.fetch({
  message_type: GET_QUICK_ACTIONS_MESSAGE_TYPE,
  info: { version }
});

// src/utils/get-quick-actions-REST.ts
import { leagueFetch } from "@leagueplatform/league-fetch";

// src/constants/care-discovery.constants.ts
var QUICK_ACTIONS_PATH = "v1/quick-actions";
var CARE_PROVIDERS_PATH = "v1/care-providers";
var PLATFORM = "web";

// src/utils/get-quick-actions-REST.ts
var getQuickActions2 = () => __async(void 0, null, function* () {
  const queryString = new URLSearchParams({
    platform: PLATFORM
  });
  const requestPath = `${QUICK_ACTIONS_PATH}?${queryString}`;
  const response = yield leagueFetch(requestPath);
  return response.json();
});

// src/utils/get-quick-action-REST.ts
import { leagueFetch as leagueFetch2 } from "@leagueplatform/league-fetch";
var getQuickAction = (quickActionId) => __async(void 0, null, function* () {
  const response = yield leagueFetch2(
    `${QUICK_ACTIONS_PATH}/${quickActionId}?include=quick-actions-parent`
  );
  return response.json();
});

// src/utils/get-care-providers.ts
import { leagueFetch as leagueFetch3 } from "@leagueplatform/league-fetch";
var getCareProviders = () => __async(void 0, null, function* () {
  const response = yield leagueFetch3(`${CARE_PROVIDERS_PATH}`);
  return response.json();
});

// src/types/care-discovery.types.ts
var QUICK_ACTIONS_TYPE = /* @__PURE__ */ ((QUICK_ACTIONS_TYPE2) => {
  QUICK_ACTIONS_TYPE2["quickAction"] = "quick-action";
  QUICK_ACTIONS_TYPE2["quickActionsParent"] = "quick-actions-parent";
  return QUICK_ACTIONS_TYPE2;
})(QUICK_ACTIONS_TYPE || {});
export {
  GET_QUICK_ACTIONS_MESSAGE_TYPE,
  QUICK_ACTIONS_TYPE,
  getCareProviders,
  getQuickAction as getQuickActionRest,
  getQuickActions,
  getQuickActions2 as getQuickActionsRest
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/care-discovery-api'] = window.leagueSDKsPresent['@leagueplatform/care-discovery-api'] || [];
    window.leagueSDKsPresent['@leagueplatform/care-discovery-api'].push('2.28.1');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/care-discovery-api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/care-discovery-api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map